import React from 'react';

class Header extends React.Component {

  render() {
    const theme = this.props.theme;
    return (
      theme ?
        <div className="bg-white flex justify-between items-center py-6 px-3 shadow-md transition-colors duration-300 lg:px-8">
          <h6 className="font-bold text-sm sm:text-lg md:text-xl">Where in the world?</h6>
          <button className="flex focus:outline-none" onClick={this.props.handleThemeChange}>
            <img src="../assets/moon.svg" alt="dark theme icon" className="w-4 h-auto mr-2 sm:w-6 md:w-8 lg:w-6" />
            <h6 className="theme-select text-xs font-medium sm:text-lg md:text-xl lg:text-base">Dark Mode</h6>
          </button>
        </div> :
        <div className="bg-gray-800 text-gray-400 flex justify-between items-center py-6 px-3 shadow-md transition-colors duration-300 lg:px-8">
          <h6 className="text-gray-400 font-bold text-sm sm:text-lg md:text-xl">Where in the world?</h6>
          <button className="flex focus:outline-none" onClick={this.props.handleThemeChange}>
            <img src="../assets/moon-white.svg" alt="dark theme icon" className="w-4 h-auto mr-2 sm:w-6 md:w-8 lg:w-6" />
            <h6 className="text-gray-400 theme-select text-xs font-medium sm:text-lg md:text-xl lg:text-base">Dark Mode</h6>
          </button>
        </div>
    );
  }
}

export default Header;
